var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{staticClass:"overflow-x-hidden",attrs:{"title":"Deepfake detection and liveness protection API | Youverse","transparent":true}},[_c('highlightSection',{attrs:{"backgroundImage":"/storage/images/products/youLive/background-img-landing.jpg","altImage":"YouID Identity Verification Platform","title":"Liveness detection API","subtitle":"ISO/IEC 30107-3 Level 1 and 2 certified liveness API. <br>Sub-second, passive, privacy-safe, and injection-resistant.","leftButton":"Start pilot","urlLeftButton":"/products/youlive#products-pricing","imageLeft":true,"leftButtonTargetBlank":false}}),_vm._v(" "),_c('LivenessComparisonSection',{attrs:{"intro":{
      title: 'Why most liveness checks fail',
      description:
        'Most vendors stop at Level 1 spoofing tests, which only catch printed photos or simple masks. Today\'s attackers use deepfakes and injection techniques that bypass weak solutions.',
    },"solution":{
      title: 'YouLive: Certified, developer-first liveness API',
      cards: [
        {
          title: 'Advanced detection',
          description:
            'Protect against identity fraud with ISO compliant liveness and injection detection.',
          highlights: [
            'ISO 30107 Level 1 and 2 compliant.',
            'Passive/active or hybrid liveness, according to business needs.',
            'Injection and deepfake detection — compliant with CEN/TS 18099.',
          ],
          cta: {
            text: 'Check certification letter',
            url: 'https://www.ibeta.com/wp-content/uploads/2024/09/240911-Youverse-PAD-Level-2-Confirmation-Letter.pdf',
            newTab: true,
          },
        },
        {
          title: 'Developer-ready',
          description:
            'Deploy liveness detection in cloud, edge, or on-prem in minutes.',
          highlights: [
            'SDKs for Web, iOS, and Android — integration in just 3 lines of code.',
            'Works in cloud, edge, or on-premises.',
            '<1s REST API latency keeps user flows frictionless.',
          ],
          cta: {
            text: 'See more',
            url: '/docs/2.x/live',
            newTab: true,
          },
        },
        {
          title: 'Private by design',
          description:
            'No storage of biometrics ensures customer data stays safe.',
          highlights: [
            'End-to-end encrypted requests.',
            'No storage of biometrics or PII.',
            'Aligned with different regulations: GDPR, CCPA, KYC/AML, and gambling/banking regulations.',
          ],
          cta: {
            text: 'Explore our privacy approach',
            url: '/faq',
            newTab: true,
          },
        },
        {
          title: 'Scalable growth',
          description:
            'Validate ROI early, then scale seamlessly — always with full cost visibility.',
          highlights: [
            'Micro-pilot (1,000 API calls over 10 days) lets you prove ROI early.',
            'Scales from 10K to 10M+ annual calls with predictable tiers.',
            'Simple per-call billing — no hidden fees, no lock-ins.',
          ],
          cta: {
            text: 'View package tiers',
            url: '/products/youlive#products-pricing',
            newTab: false,
          },
        },
        {
          title: 'Trusted standards',
          description:
            'Built with regulators, global standards, and high-stake sectors.',
          highlights: [
            'Continuous ISO compliance checks.',
            'Partnerships with regulators, academics, and standards bodies.',
            'Industry-specific compliance for banking and governments.',
          ],
          cta: {
            text: 'Learn more',
            url: 'https://www.youverse.id/resources/press/ijcb-2025-concludes-with-insights-on-face-recognition-security',
            newTab: true,
          },
        },
        {
          title: 'Fair verification',
          description:
            'Equal accuracy across all skin tones, genders, and ages.',
          highlights: [
            'Equal accuracy across skin tones, genders, and ages.',
            'Bias reduction built into model design.',
            'Reliable verification for diverse demographics.',
          ],
          cta: {
            text: 'See details',
            url: 'https://www.youverse.id/resources/blog/what-is-responsible-ai',
            newTab: true,
          },
        },
      ],
    }}}),_vm._v(" "),_c('section4',{attrs:{"title":"Independently verified","description":"Independently tested and validated against industry standards, ensuring transparency, accountability, and trust with no black-box vendor claims.","images":[
      {
        src: '/storage/images/products/face/ibeta_level1.png',
        alt: 'Ibeta Level 1',
        style: 'h-8 md:h-10 lg:h-12',
      },
      {
        src: '/storage/images/products/face/ibeta_level2.png',
        alt: 'Ibeta Level 2',
        style: 'h-8 md:h-10 lg:h-12',
      },
      {
        src: '/storage/images/products/face/GDPR_Compliant.png',
        alt: 'GDPR Compliant',
        style: 'h-8 md:h-10 lg:h-12',
      },
    ]}}),_vm._v(" "),_c('PricingSection',{attrs:{"product-name":"youlive","title":"Simple, transparent pricing","description":"Choose the plan that fit your needs. Scale up at your pace."}}),_vm._v(" "),_c('div',{staticClass:"sm:mt-14"},[_c('cta',{attrs:{"title":"Build trust before commitment ","text":"Run a free pilot today and scale confidently to enterprise volumes tomorrow.","buttonText":"Start now","buttonLink":"/products/youlive#products-pricing"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }